import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';



// NICOLAS 19-08-2025=> BORRAR PORQUE NO TIENE SENTIDO PARA EL FRONT PORQUE VAN A SER TODOS DISTINTOS
const host = window.location.hostname;
switch (host) {
  case 'aqa.eco':
    environment.apiUrl = 'https://api.aqa.eco/api/';
    break;

  case 'test-front.argenfil.com.ar':
    environment.apiUrl = 'https://test-api.argenfil.com.ar/api/';
    break;

  case 'hogares.everfull.com.ar':
    environment.apiUrl = 'https://api.everfull.com.ar/api/';
    break;

  case 'test.everfull.com.ar':
    environment.apiUrl = 'https://api-test.everfull.com.ar/api/';
    break;

  case 'argenfil.com.ar':
    environment.apiUrl = 'https://apiv2.argenfil.com.ar/api/';
    break;

  default:
    //environment.apiUrl = 'http://localhost:8000/api/';
    environment.apiUrl = 'https://api.everfull.com.ar/api/';
    break;
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
